import { DeliveryAddress } from '../generic/info'
import { ObjectListRequestType } from '../ObjectListResponseTypes'
import { ObjectListType } from '../ObjectListTypes'

/**
 * Enum for every specific status ID provided.
 */
export enum SalesOrderStatusId {
  Quotation = 20,
  WaitingForApproval = 30,
  WaitingForFulfillmentInitiation = 40,
  WaitingForFulfillmentCompletion = 50,
  Fulfilled = 70,
  Ended = 75,
  Cancelled = 80,
  Rejected = 90,
  QuotationRejected = 95,
}

export enum BuildingBlockStatusId {
  Created = 10,
  WaitingForFulfillmentApproval = 20,
  WaitingForFulfillmentInitiation = 22,
  WaitingForFulfillmentAddressValidation = 23,
  WaitingForFulfillmentManual = 24,
  WaitingForFulfillmentPostponed = 25,
  WaitingForFulfillmentCompletion = 26,
  Fulfilled = 30,
  WaitingForCleanUpApproval = 40,
  WaitingForCleanUpInitiatio = 42,
  WaitingForCleanUpManual = 44,
  WaitingForCleanUpCompletion = 46,
  Removed = 50,
  FulfillmentError = 99,
}

export interface OrderList extends ObjectListType {
  orders: Order[]
}

export interface OrderInstallation {
  date: string
  type: string
  typeId: number
  status: string
  statusId: number
}

export interface OrderOption {
  optionId: number
  name: string
  statusId: number
  status: string
  subscriptionType: string
}

export interface Order {
  id: number
  orderId: number
  date: string
  description: string
  statusId: number
  status: string
  partner: string
  installations: OrderInstallation[]
  options: OrderOption[]
}

export interface OrderRequest extends ObjectListRequestType {
  sortOrder?: string | null
  sortBy?: string | null
}

export interface BulkOrderRequest {
  amount: number
  beneficiary: string
  companyName: string
  address: DeliveryAddress
}

export interface OrderStep {
  label: string
}

export interface Addon {
  success: boolean
  saleid: string
  errorMessage: string
  processedAt: string
}

export const isOrderList = (orderlist: any): orderlist is OrderList => {
  if (orderlist === undefined) {
    return false
  }
  return 'orders' in orderlist
}

export const isOrder = (item: any): item is Order => {
  // A valid, single Order must be an object, not an array,
  // and have an 'orderId' property.
  if (item === undefined || item === null || Array.isArray(item)) {
    return false
  }
  return typeof item === 'object' && 'orderId' in item
}

export const isOrderRequest = (request: any): request is OrderRequest => {
  if (request === undefined) {
    return false
  }
  // prevent ticket false positive
  return 'statusid' in request && 'ticketId' in request === false
}

export const isAddon = (item: any): item is Addon => {
  if (item === undefined || item === null || Array.isArray(item)) {
    return false
  }
  return typeof item === 'object' && 'saleid' in item && 'success' in item
}
